import { promises as fs } from 'fs';
import path from 'path';
import MediaToolsPageComponent, { generateMediaToolsProps, MediaToolsPageProps } from '../components/media-tools/media-tools-page.component';

interface PageProps extends MediaToolsPageProps {
    url: string;
}

export async function getStaticProps() {
    // 1. Generate media tools props from selector-options.json
    const selectorPath = path.join(process.cwd(), 'public/selector-options/selector-options.json');
    const selectorContents = await fs.readFile(selectorPath, 'utf8');
    const selectorOptions = JSON.parse(selectorContents);

    const mediaToolsProps = generateMediaToolsProps('video-tools', selectorOptions);
    if (!mediaToolsProps) {
        return { notFound: true };
    }

    // 2. Read page-specific SSR data (SEO, markdown, ratings, etc.)
    const ssrDataPath = path.join(process.cwd(), 'ssr-data/build/video-tools.json');
    let ssrProps = {};
    try {
        const ssrData = await fs.readFile(ssrDataPath, 'utf8');
        ssrProps = JSON.parse(ssrData);
    } catch (e) {
        // SSR data file may not exist for all pages
    }

    // 3. Merge both - mediaToolsProps takes precedence for features
    return {
        props: {
            ...ssrProps,
            ...mediaToolsProps,
            url: '/video-tools',
        }
    };
}

export default function VideoToolsPage(props: PageProps) {
    return <MediaToolsPageComponent {...props} />;
}
